import { Title } from '../../../../../components/Title'
import verifySymbol from '../../../../../assets/verify-id-icon.svg';

export const VerifyTitle = () => <Title title='Verify Identity'>
  <img alt='verify' src={verifySymbol} />
</Title>;